import * as React from 'react';
import { useSelector } from 'react-redux';

import { Promo } from './Promo';
import { Promos as PromosComponent } from '../../../components/NewbuildingPromos/parts/Promos';
import { getNewbuildingPromos, getOffer } from '../../../selectors/newObject';
import { EPromoType, IPromoInfo } from '../../../types/newbuildingPromos';
import { ToggleButton } from '../ToggleButton';
import { trackMorePromosClick } from '../tracking';

export const Promos = () => {
  const promos = useSelector(getNewbuildingPromos);
  const offer = useSelector(getOffer);

  const onChangeOpen = React.useCallback((opened: boolean) => {
    if (opened) {
      trackMorePromosClick();
    }
  }, []);

  if (!promos || !promos.length) {
    return null;
  }

  return (
    <PromosComponent Button={ToggleButton} onChangeOpen={onChangeOpen}>
      {promos.map((promo: IPromoInfo) => (
        <Promo
          key={promo.uniquePromoId}
          promo={promo}
          offer={offer}
          isMainDiscountPromo={promo.isMainPromo && promo.promoType === EPromoType.Discount}
        />
      ))}
    </PromosComponent>
  );
};

Promos.displayName = 'Promos';
